export default __webpack_public_path__ + "static/media/eight.8ac4ba4d.jpeg";